<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Map Salary Rule Offering To Salary Component</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br />
      <v-row dense justify="center">
        <v-autocomplete dense rounded outlined class="ml-5 mr-5 pt-1" v-model="sc_id" :items="salary_component_list"
          item-text="s_d_name" return-object label="Select Salary Component" persistent-hint
          single-line></v-autocomplete>
        <v-autocomplete dense rounded outlined class="ml-5 mr-5 pt-1" v-model="scr_id" :items="component_rule"
          item-text="name" return-object label="Select Salary Rule" persistent-hint single-line></v-autocomplete>
        <v-btn v-if="sc_id && scr_id" class="button pt-none mt-none" @click="save()">Save/Update</v-btn>
        <v-btn v-if="sc_id && scr_id" class="button pt-none mt-none" @click="
            sc_id = null;
            scr_id = null;
          ">Reset</v-btn>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3" md="3" v-if="map_component_rule.length != 0">
          <!-- <v-btn color="success" outlined rounded>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="map_component_rule"
              :fields="table_fields"
              worksheet="PayRollMapSalaryRuleTOComponent"
              name="PayRollMapSalaryRuleTOComponent.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn> -->
          <v-btn class="mr-2 pb-3 pt-2" rounded color="success" outlined
            @click="fnExcelReport('my-table-id', 'MapSalaryRuleToComponent')" :loading="loader"><v-icon
              color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
      </v-row>
      <div id="my-table-id">
        <v-data-table v-if="map_component_rule != ''" :headers="headers" dense :items="map_component_rule"
          class="elevation-1 mytable" :search="search">
          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    // extraBreadcrumbItems: [
    //   { text: "Map Salary Rule To Component", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    valid: false,
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    map_component_rule: [],
    salary_component_list: [],
    sc_id: null,
    scr_id: null,
    srcoid: null,
    component_rule: [],
    headers: [
      {
        text: "Rule",
        align: "left",
        sortable: false,
        value: "sr_rule",
      },
      {
        text: "Component Name",
        align: "left",
        sortable: false,
        value: "sr_component",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      Rule: "sr_rule",
      "Component Name": "sr_component",
    },
  }),
  mounted() {
    this.onLoad();
  },
  methods: {
     fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    editItem(item) {
      this.srcoid = item;
      const data = {
        srcoid: this.srcoid.srcoid,
      };
      axios
        .post("/Payroll/getMapComponentRuleData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.sc_id = res.data.comp_data[0];
            this.scr_id = res.data.rule_data[0];
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {});
    },
    save() {
      var id;
      if (this.srcoid) {
        id = this.srcoid.srcoid;
      } else {
        id = "NA";
      }
      const data = {
        srcoid: id,
        sid: this.sc_id.s_id,
        srid: this.scr_id.id,
      };
      axios
        .post("/Payroll/saveComponentRule", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.onLoad();
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "Already Present!!!");
            this.onLoad();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          (this.sc_id = null), (this.scr_id = null), this.onLoad();
        });
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/mapComponentRule")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.map_component_rule = res.data.map_component_rule;
            this.salary_component_list = res.data.salary_component_list;
            this.component_rule = res.data.component_rule;
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
